import React, { useState } from 'react';
import './App.css';
import { Package, DollarSign, Users, ClipboardList, TrendingUp, ArrowLeft, LogOut } from 'lucide-react';
import Products from './components/Products';
import Sales from './components/Sales';
import Clientes from './components/Clientes';
import Financials from './components/Financials';
import ProductManagement from './components/ProductManagement';
import BottomNav from './components/BottomNav';
import Login from './components/Login';
import { useAuth } from './AuthProvider';

const NAV_ITEMS: { key: string; label: string; icon: React.ComponentType<any> }[] = [
  { key: 'products', label: 'Productos', icon: Package },
  { key: 'sales', label: 'Ventas', icon: DollarSign },
  { key: 'clientes', label: 'Clientes', icon: Users },
  { key: 'financials', label: 'Financieros', icon: TrendingUp },
];

function Sidebar({ active, onSelect }: {
  active: string;
  onSelect: (key: string) => void;
}) {
  return (
    <aside className="sidebar">
      <div className="sidebar-title">MarFrutal</div>
      <nav>
        {NAV_ITEMS.map(item => {
          const IconComponent = item.icon;
          return (
            <div
              key={item.key}
              className={`nav-item${active === item.key ? ' active' : ''}`}
              onClick={() => onSelect(item.key)}
            >
              <IconComponent className="sidebar-nav-icon" size={20} />
              {item.label}
            </div>
          );
        })}
      </nav>
    </aside>
  );
}

function Header({ currentPage, showProductManagement, onAdministrarClick, onSignOut }: { currentPage: string; showProductManagement: boolean; onAdministrarClick: () => void; onSignOut: () => void }) {
  return (
    <header className="header">
      {currentPage === 'products' && (
        <button className="btn-ghost btn-small" onClick={onAdministrarClick} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          {showProductManagement ? <><ArrowLeft size={16} />Regresar</> : <><ClipboardList size={16} />Inventario</>}
        </button>
      )}
      <div style={{ marginLeft: 'auto' }}>
        <button className="btn-ghost btn-small" onClick={onSignOut} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <LogOut size={16} />
          Logout
        </button>
      </div>
    </header>
  );
}

function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 1024);
  React.useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isMobile;
}

function App() {
  const { user, loading, signOut } = useAuth();
  const [page, setPage] = useState('products');
  const [productsKey, setProductsKey] = useState(0);
  const [showProductManagement, setShowProductManagement] = useState(false);
  const isMobile = useIsMobile();
  
  if (loading) {
    return null;
  }

  if (!user) {
    return <Login />;
  }

  const handleMenuSelect = (key: string) => {
    if (key === 'products') {
      setProductsKey(k => k + 1);
    }
    setPage(key);
    setShowProductManagement(false);
  };

  const handleAdministrarClick = () => {
    setShowProductManagement(prev => !prev);
  };
  
  return (
    <div className="dashboard-root">
      {isMobile ? (
        <div className="dashboard-main">
          <Header currentPage={page} showProductManagement={showProductManagement} onAdministrarClick={handleAdministrarClick} onSignOut={signOut} />
          <main className="main-content">
            {showProductManagement ? <ProductManagement /> :
             page === 'products' ? <Products key={productsKey} /> :
             page === 'sales' ? <Sales /> :
             page === 'clientes' ? <Clientes /> :
             page === 'financials' ? <Financials /> : null}
          </main>
          <BottomNav active={page} onSelect={handleMenuSelect} navItems={NAV_ITEMS} />
        </div>
      ) : (
        <>
          <Sidebar active={page} onSelect={handleMenuSelect} />
          <div className="dashboard-main">
            <Header currentPage={page} showProductManagement={showProductManagement} onAdministrarClick={handleAdministrarClick} onSignOut={signOut} />
                      <main className="main-content">
            {showProductManagement ? <ProductManagement /> :
             page === 'products' ? <Products key={productsKey} /> :
             page === 'sales' ? <Sales /> :
             page === 'clientes' ? <Clientes /> :
             page === 'financials' ? <Financials /> : null}
          </main>
          </div>
        </>
      )}
    </div>
  );
}

export default App;
